import DB from '../../DAL/DB'

const locks = new DB.ProjectLocks()

export async function breakLock(id) {
  await locks.delete(id)
}
